import Immutable from "immutable"

import { mapToUtcMoment } from "../momentHelpers/momentHelpers"
import Transfer from "../../records/Transfer"

export default function(obj) {
  const formatTerminal = departure => {
    if (!departure || departure === "-") return null
    return departure
  }

  // Same format flights, checkflights
  return new Transfer({
    id: obj.id,
    type: obj.type || "bus",
    departure: Immutable.fromJS({
      where: {
        code: obj.src.airport, // LTN
        name: obj.src.name, // London
        terminal: formatTerminal(obj.src.terminal), // 2
      },
      when: {
        local: mapToUtcMoment(obj.dtime),
        // Only tmp solution - all will have `dtime_utc`
        utc: obj.dtime_utc
          ? mapToUtcMoment(obj.dtime_utc) // TODO: Calculate
          : mapToUtcMoment(obj.dtimeUTC),
      },
    }),
    arrival: Immutable.fromJS({
      where: {
        code: obj.dst.airport, // LTN
        name: obj.dst.name, // London
        terminal: formatTerminal(obj.dst.terminal), // 2
      },
      when: {
        local: mapToUtcMoment(obj.atime),
        utc: obj.atime_utc
          ? mapToUtcMoment(obj.atime_utc) // TODO: Calculate
          : mapToUtcMoment(obj.atimeUTC), // TODO: Calculate
      },
    }),
    carrier: Immutable.fromJS({
      code: obj.carrier.toLowerCase(), // TODO: Better
      name: obj.carrier,
      // logo: obj["logoUrl"] ? obj["logoUrl"] : "/images/icons/transfer.svg" // Use default logo if logo url unavailable
      logo: "/images/icons/transfer.svg", // Use default logo now
    }),
  })
}
